import { FolderOpen } from "lucide-react";

type Props = {
  isOpen: boolean;
  onDismiss: () => void;
};

export default function OneDriveSetupModal({ isOpen, onDismiss }: Props) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="w-full max-w-sm rounded-xl border border-gray-700 bg-gray-900 p-6 shadow-2xl mx-4">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gray-800">
            <FolderOpen className="h-5 w-5 text-gray-300" />
          </div>
          <h2 className="text-base font-semibold text-gray-100">AI Notes</h2>
        </div>

        <p className="text-sm text-gray-400 mb-4">
          Welcome. I created a folder on your OneDrive that will be used to store notes from our conversations.
        </p>

        <div className="flex justify-end">
          <button
            onClick={onDismiss}
            className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-500 transition-colors"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
